export default __webpack_public_path__ + "asset/img/icon-finger~e53ee33a.png";